import { createFeatureSelector, createSelector } from '@ngrx/store'
import { PROJECTORS_FEATURE_KEY, ProjectorsState, projectorsAdapter } from './projectors.reducer'

// Lookup the 'Projectors' feature state managed by NgRx
export const selectProjectorState = createFeatureSelector<ProjectorsState>(PROJECTORS_FEATURE_KEY)

const { selectAll, selectEntities } = projectorsAdapter.getSelectors()

export const selectProjectorLoaded = createSelector(selectProjectorState, (state: ProjectorsState) => state.loaded)

export const selectAllProjector = createSelector(selectProjectorState, (state: ProjectorsState) => selectAll(state))

export const selectProjectorEntities = createSelector(selectProjectorState, (state: ProjectorsState) =>
  selectEntities(state),
)

export const selectSelectedId = createSelector(selectProjectorState, (state: ProjectorsState) => state.selectedId)

export const selectEntity = createSelector(selectProjectorEntities, selectSelectedId, (entities, selectedId) =>
  selectedId ? entities[selectedId] : undefined,
)

export const selectAllProjectorTemplates = createSelector(selectProjectorState, (state: ProjectorsState) =>
  [...(state.projectorTemplates || [])].sort((a, b) => a.name.localeCompare(b.name)),
)

export const selectTemplatesLoaded = createSelector(
  selectProjectorState,
  (state: ProjectorsState) => state.templatesLoaded,
)

export const selectEditCreateLoaded = createSelector(
  selectProjectorState,
  (state: ProjectorsState) => state.editCreateLoaded,
)

export const selectPresenterEditToken = createSelector(
  selectProjectorState,
  (state: ProjectorsState) => state.presenterEditToken,
)
